import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-idling",
  "use": "icon-status-idling-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-status-idling\">\n<rect x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" rx=\"9.5\" fill=\"white\" />\n<rect x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" rx=\"9.5\" stroke=\"#DAA520\" />\n<path d=\"M10.5 10.5H9.5V7.5H10.5M9.5 11.5H10.5V12.5H9.5M11.865 5.5H8.135L5.5 8.135V11.865L8.135 14.5H11.865L14.5 11.865V8.135L11.865 5.5Z\" fill=\"#DAA520\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol